import React from 'react';
import { Paper, Box, Button, Typography } from '@material-ui/core';
import { Form } from 'react-final-form';
import { uploadTypes } from '../../../../config/constants';
import ImageUploadField from '../ImageUploadField';

const LoadingScreenTab = ({ config, onSave }) => {
  const handleSubmit = (values) => {
    onSave({
      ...config,
      loading_background: values.loading_background,
      loading_overlay_image: values.loading_overlay_image,
    });
  };

  const initialValues = {
    loading_background: config?.loading_background,
    loading_overlay_image: config?.loading_overlay_image,
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Loading Screen Settings
        </Typography>
        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap={2}>
                <ImageUploadField
                  name="loading_background"
                  label="Background Image"
                  uploadType={uploadTypes.wordFinder}
                  helperText="Minimum 375Wx825H"
                />

                <ImageUploadField
                  name="loading_overlay_image"
                  label="Overlay Image (floating element)"
                  uploadType={uploadTypes.wordFinder}
                  helperText="The app allows filling up to 70% of the screen width, the height adjusts accordingly"
                />

                <Box mt={3}>
                  <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                    Save Loading Screen Settings
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Box>
    </Paper>
  );
};

export default LoadingScreenTab;
